<div [innerHTML]="text" class="answer">
</div>